import React, { useState, useRef, useEffect } from 'react';
import Dragger from 'antd/lib/upload/Dragger';
import {
  DownloadOutlined, DeleteOutlined, EyeOutlined,
  InboxOutlined,
} from '@ant-design/icons';
import {
  Col, Row, Button, Input, Form, notification, Modal, Upload, Collapse, Popconfirm,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import fileDownload from '../../../../utils/fileDownload';
import fileOpenNewTab from '../../../../utils/fileOpenNewTab';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { editApplications2, uploadFile } from '../../../../utils/http';


export const FilesModal = ({
  application, onHide, onSuccess, files, fieldName, postMethod
}) => {
  const [selectedFiles, setSelectedFiles] = useState({ id: undefined, pdf: {}, docx: {} });

  useEffect(() => {
    // Если файлы есть - ставим их
    if (files) {
      console.log(files);
      setSelectedFiles(files);
    }
  }, [files]);

  const handleClose = () => {
    onHide();
  };

  const handleFileInputChange = (e, type) => {
    setSelectedFiles({
      ...selectedFiles,
      [type]: e.file,
    });
  };

  const handleRemoveFile = (type) => {
    setSelectedFiles({
      ...files,
      [type]: {},
    });
  };


  const handleSubmit = async () => {
    if (!selectedFiles.pdf?.name) {
      notification.error({ message: 'Загрузите файл PDF' });
      return;
    }

    if (!selectedFiles.docx?.name) {
      notification.error({ message: 'Загрузите файл Word' });
      return;
    }

    try {
      // Загружаем PDF если его нет
      let uploadedPDF = null;
      if (!selectedFiles.pdf.urlLink) {
        const form = new FormData();
        const headers = {
          'Content-Type': 'multipart/form-data',
        };
        form.append('file', selectedFiles.pdf.originFileObj);
        uploadedPDF = await uploadFile(form, headers);
      }

      // Загружаем DOC если его нет
      let uploadedDOC = null;
      if (!selectedFiles.docx.urlLink) {
        const form = new FormData();
        const headers = {
          'Content-Type': 'multipart/form-data',
        };
        form.append('file', selectedFiles.docx.originFileObj);
        uploadedDOC = await uploadFile(form, headers);
      }

      // Utility функция для новых файлов
      const createFileObj = (file) => ({
        name: file.name,
        urlLink: file.urlLink,
        id: file.id,
      });


      const prevFiles = structuredClone(application[fieldName]) || [];
      const isPrevFile = prevFiles?.find((f) => f.id === files.id);

      let jsonData = '';
      // Уже есть файл с таким айди - заменяем в нем
      if (isPrevFile) {
        isPrevFile.pdf = uploadedPDF ? createFileObj(uploadedPDF) : files.pdf;
        isPrevFile.docx = uploadedDOC ? createFileObj(uploadedDOC) : files.docx;

        jsonData = JSON.stringify(prevFiles);
      } else {
        // Если нет - добавляем новый
        const uploadedObj = {
          id: uuidv4(),
          pdf: createFileObj(uploadedPDF),
          docx: createFileObj(uploadedDOC),
        };
        jsonData = JSON.stringify([...prevFiles, uploadedObj]);
      }

      // Тут составляем тело запроса с именем поля и новыми файлами
      const body = {
        id: application.id,
        [fieldName]: jsonData,
      };

      // Сохраняем в D
      await postMethod(body);
      notification.success({ message: 'Файлы загружены' });

      // Говорим родителю, что все ок
      onSuccess();
    } catch (e) {
      console.log(e);
      notification.error({ message: 'Ошибка. Попробуйте еще раз' });
    }
  };


  return (
    <Modal
      visible
      width="70vw"
      maskClosable={false}
      onCancel={handleClose}
      title={`Загрузка файлов для ${application.displayID}`}
      footer={[
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Сохранить
        </Button>,
      ]}
    >
      <Col>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontWeight: 'bold' }}>Файл pdf</div>
          {!selectedFiles.pdf?.name && (
            <Dragger
              showUploadList={false}
              onChange={(e) => handleFileInputChange(e, 'pdf')}
              action={null}
              accept=".pdf"
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Выберите или перенесите файл, чтобы загрузить (не более 15мб).</p>
            </Dragger>
          )}

          {selectedFiles.pdf?.name && (
            <div style={{ display: 'flex', flexDirection: 'column', margin: '5px 0px' }}>
              <div>{selectedFiles.pdf.name}</div>
              <div>
                <Button disabled={!selectedFiles.pdf.urlLink} title={selectedFiles.pdf.urlLink ? 'Скачать' : 'Файл еще не загружен'} type="primary" onClick={() => fileDownload(selectedFiles.pdf.urlLink, selectedFiles.pdf.name)}>Скачать</Button>
                <Button disabled={!selectedFiles.pdf.urlLink} title={selectedFiles.pdf.urlLink ? 'Открыть' : 'Файл еще не загружен'} type="primary" onClick={() => fileOpenNewTab(selectedFiles.pdf.urlLink)} style={{ margin: '0px 10px' }}>Открыть</Button>
                <Popconfirm
                  title="Уверены, что хотите удалить файл?"
                  onConfirm={() => handleRemoveFile('pdf')}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Button type="danger" disabled={getUserRole() !== 'bigAdmin'}>Удалить</Button>
                </Popconfirm>
              </div>
            </div>
          )}

          <div style={{ fontWeight: 'bold' }}>Файл word</div>
          {!selectedFiles.docx?.name && (
            <Dragger
              showUploadList={false}
              onChange={(e) => handleFileInputChange(e, 'docx')}
              action={null}
              accept=".docx,.doc"
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Выберите или перенесите файл, чтобы загрузить (не более 15мб).</p>
            </Dragger>
          )}
          {selectedFiles.docx?.name && (
            <div style={{ display: 'flex', flexDirection: 'column', margin: '5px 0px' }}>
              <div>{selectedFiles.docx.name}</div>
              <div>
                <Button disabled={!selectedFiles.docx.urlLink} style={{ marginRight: '10px' }} title={selectedFiles.docx.urlLink ? 'Скачать' : 'Файл еще не загружен'} type="primary" onClick={() => fileDownload(selectedFiles.docx.urlLink, selectedFiles.docx.name)}>Скачать</Button>
                <Popconfirm
                  title="Уверены, что хотите удалить файл?"
                  onConfirm={() => handleRemoveFile('docx')}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Button type="danger" disabled={getUserRole() !== 'bigAdmin'}>Удалить</Button>
                </Popconfirm>
              </div>
            </div>
          )}

        </div>
      </Col>
    </Modal>
  );
};

FilesModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  application: PropTypes.shape().isRequired,
  files: PropTypes.shape().isRequired,
  onSuccess: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  postMethod: PropTypes.func.isRequired,
};
